import HundredBricksAPIError from '../../../../HundredBricksAPIError';
class BricksOnSaleSummaryError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('BricksOnSaleSummaryError', ...args);
    }
}
export default BricksOnSaleSummaryError;
